import { render } from "./TestValidator.vue?vue&type=template&id=f457c5a2"
import script from "./TestValidator.vue?vue&type=script&lang=js"
export * from "./TestValidator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__